import React from 'react';
import Button from 'src/app/atoms/Button/Button';
import RankedG2WithTextBlock from 'src/app/molecules/RankedG2WithTextBlock/RankedG2WithTextBlock';

const RankedG2 = (): JSX.Element => {
  return (
    <RankedG2WithTextBlock
      heading={{
        text: 'Ranked #1 by G2',
        type: 'heading',
        size: 'xl',
        fontWeight: 'font-weight-semibold',
      }}
      supportingText={{
        type: 'paragraph',
        size: 'xl',
        fontWeight: 'font-weight-regular',
        textAlign: 'left',
        children: (
          <>
            With a satisfaction score of 99 out of 100—and a team obsessing over getting that final point.
            <br />
            <br />
            *We know, people <i>love</i> to say this. When we say it?
          </>
        ),
      }}
      additionalContent={
        <Button
          variant='brand-text-link'
          size='xl'
          href='https://www.g2.com/categories/online-community-management?tab=highest_rated'
        >
          It’s true. 😎
        </Button>
      }
    />
  );
};

export default RankedG2;
